import React, {useContext} from "react";
import {
    eachMonthOfInterval, format, endOfMonth, eachWeekOfInterval, endOfWeek
} from 'date-fns';
import {ru, enUS} from "date-fns/locale";
import {Link} from "react-router-dom";
import {LanguageContext} from "../../App";
import {isMobile} from "react-device-detect";

const Ranges = () => {
    const {language} = useContext(LanguageContext)
    // let start =
    // let end =
    let interv = {start:new Date(2022,2,24), end:new Date()}
    const monthes = eachMonthOfInterval(interv)

    const weeks = (month) => {
        let wks = eachWeekOfInterval({
            start: month,
            end: endOfMonth(month)
        })
        return (
            <ul className='list-disc'>
                {wks.map((week, index)=>
                    <li key={index} className='ml-4'>
                        <Link className='hover:font-medium' to={((language.name === 'en')? '/en': '') + '/range?start=' + format(week,'dd-MM-yy') +
                                '&end='+  format(endOfWeek(week),'dd-MM-yy')
                                }
                        >
                            <span>{index+1} {language.main_page.side_bar.archive.week} </span>
                            <span className='text-gray-500'>{format(week,'dd.MM')} - {format(endOfWeek(week),'dd.MM')}</span>
                        </Link>
                    </li>
                )}
            </ul>
        )
    }

    return (
        <div className='w-full bg-white' style={isMobile ? {height: '90%'} : {height: '95%'}}>
            <ul className='p-4'>
                <h2 className='pb-2'>{language.main_page.side_bar.archive.title}</h2>
                {monthes.map((month, index) =>
                    <li key={index}>
                        <Link className='capitalize hover:font-medium'
                              to={'/range?start=' + format(month, 'dd-MM-yy') +
                                  '&end=' + format(endOfMonth(month), 'dd-MM-yy')
                              }
                        >
                            {format(month, 'LLLL', { locale: language.name==='en' ? enUS : ru})}
                        </Link>
                        {weeks(month)}
                    </li>
                )}
            </ul>
        </div>
    )
}

export default Ranges